import React from 'react'
import classNames from 'classnames'

import { Button } from 'components/base'
import RoutesHelper from 'helpers/RoutesHelper'

const Header = ({
  freePlan,
  organizationPhotoURL,
  organizationName,
  channelId,
  alreadyJoined,
}) => {
  const utmType = channelId ? 'channel' : 'note'
  const loggedInAndLoaded = Boolean(
    organizationName && organizationPhotoURL && alreadyJoined
  )
  return (
    <div
      className={classNames(
        'public-top-bar',
        'height-full',
        'flexbox flexbox-space-between flexbox-align-center',
        'background-shade-100 shadow-normal'
      )}
    >
      <div>
        {freePlan && (
          <a
            href={`https://slite.com/?utm_source=public-share-${utmType}&utm_campaign=public-share-${utmType}-cta-signup`}
          >
            <img
              src="https://storage.googleapis.com/slite-cdn/logos/slite/color.svg"
              height="24"
              style={{ height: 24 }}
              alt="slite"
            />
          </a>
        )}
      </div>
      <div>
        {loggedInAndLoaded ? (
          <a
            href={RoutesHelper.app()}
            className="flexbox flexbox-align-center pointer"
          >
            <img
              src={organizationPhotoURL}
              alt="company"
              style={{ width: 24, height: 24 }}
              className="margin-right-normal shadow-small radius-round"
            />
            <div className="shade-10 font-weight-medium font-size-large">
              {organizationName}
            </div>
          </a>
        ) : (
          <div className="flexbox flexbox-align-center">
            <a href={RoutesHelper.login()}>
              <Button.Secondary
                className="border-none"
                style={{ boxShadow: null }}
              >
                Sign in
              </Button.Secondary>
            </a>
            <a href={'https://slite.com/organization/create'}>
              <Button.Primary>Sign up</Button.Primary>
            </a>
          </div>
        )}
      </div>
    </div>
  )
}

export default Header
